import React from "react";
import { cn } from "lib/utils";

interface Props {
    message?: string;
    /** Compact layout for overlays (e.g. list backdrop). */
    inline?: boolean;
    /** Full viewport overlay — used during initial app bootstrap. */
    fullScreen?: boolean;
}

const Loader: React.FC<Props> = ({ message, inline = false, fullScreen = false }) => {
    const label = message ?? "Loading";

    return (
        <div
            className={cn(
                "flex flex-col items-center justify-center gap-4",
                fullScreen && "fixed inset-0 z-50 bg-background",
                !inline && !fullScreen && "min-h-[50vh] py-16",
            )}
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <div className="relative flex h-14 w-14 items-center justify-center" aria-hidden>
                <div className="absolute inset-0 rounded-full border-[3px] border-[#0F2462]/15" />
                <div className="absolute inset-0 animate-spin rounded-full border-[3px] border-transparent border-t-[#4C4CF4] border-r-[#4C4CF4]/60" />
                <div
                    className="absolute inset-2 animate-spin rounded-full border-[3px] border-transparent border-b-[#0F2462] border-l-[#0F2462]/50"
                    style={{ animationDirection: "reverse", animationDuration: "1.2s" }}
                />
                <div className="h-2.5 w-2.5 rounded-full bg-[#4C4CF4]" />
            </div>

            {message ? (
                <p className="text-sm font-medium tracking-wide text-[#0F2462]/70">{message}</p>
            ) : (
                <span className="sr-only">{label}</span>
            )}
        </div>
    );
};

export default Loader;
